import classes from "./ClemAi.module.scss";
import Banner from "./Banner/Banner";
import OurStrategy from "./OurStrategy/OurStrategy";
import GlobalPresence from "../LandingPage/GlobalPresence/GlobalPresence";
import WhoWeHelp from "./WhoWeHelp/WhoWeHelp";
import GetInTouch from "../../Components/GetInTouch/GetInTouch";

function ClemAi() {
  return (
    <div className={classes.container}>
      <Banner />
      <GlobalPresence />
      <OurStrategy />
      <WhoWeHelp />
      <GetInTouch />
    </div>
  );
}

export default ClemAi;
